import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';
import { Container } from 'flux/utils';
import { withId } from '../Common/Decorators';
import ComplianceStore from '../../stores/ComplianceStore';
import ComplianceProgressStore from '../../stores/ComplianceProgressStore';
import { getCompliance, getComplianceProgress, openDeleteDialog } from '../../actions/ComplianceActionCreator';
import DetailView from '../Common/DetailView';
import BasicProgressBar from '../ProgressBar/BasicProgressBar';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import ComplianceIcon from 'material-ui/svg-icons/action/assignment-turned-in';
import IconChart from 'material-ui/svg-icons/editor/insert-chart';

import UserProgressIcon from 'material-ui/svg-icons/action/perm-identity';
import SkillProgressIcon from 'material-ui/svg-icons/social/public';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ComplianceDeleteDialog from './ComplianceDeleteDialog';
import IconButton from 'material-ui/IconButton';
import buildContextMenu from '../Common/BuildContextMenu';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';

import ROLES from '../../constants/Roles';
import { statusColours } from '../../constants/ColourConstants';

const dataRow = (total, type) => ({id, name, isTrainerSkill, completed}) => (
    <div key={id}>
        {!!total && <BasicProgressBar total={total} completed={completed} />}
        <p className="progressBar-label">
            <Link to={`/dashboard/${type}/${id}`}>{name}</Link> {completed} / {total}
        </p>
    </div>
);

const SkillProgress = ({compliance = {}, data = []}) => {

    if (!compliance || !compliance.skillCount || !compliance.userCount) { return null; } // guard

    const completed = data.reduce((sum, {completed}) => sum + completed, 0);
    const totalSkills = compliance.skillCount * compliance.userCount;
    const percentage = totalSkills ? Math.round((completed / totalSkills) * 100) : 0;

    return (
        <div className="content-left">
            <div className={'cent-progress-bar-circular'}>
                <CircularProgressbar
                    strokeWidth={12}
                    value={completed}
                    maxValue={totalSkills}
                    text={`${percentage}%`}
                    styles={buildStyles({
                        rotation: 0.25,
                        strokeLinecap: 'butt',
                        textSize: '18px',
                        pathTransitionDuration: 0.5,
                        pathColor: statusColours.primary,
                        textColor: statusColours.default,
                        trailColor: statusColours.disabled,
                        backgroundColor: statusColours.primary_2,
                    })}
                />
            </div>
        </div>
    )
};

class ComplianceProgress extends Component {

    componentWillMount() {
        getCompliance(this.props.id);
        getComplianceProgress(this.props.id);
    }

    toggleView() {
        browserHistory.replace(`/dashboard/compliance/${this.props.id}/progress/${this.props.type === 'user' ? 'skill' : 'user'}`);
    }

    getMenuItems() {
        return [
            {
                link: `/dashboard/compliances`,
                icon: <ComplianceIcon />,
                label: 'Compliance list',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                action: () => this.toggleView(),
                icon: <UserProgressIcon />,
                label: 'Progress by user',
                condition: {
                    show: this.props.type !== 'user',
                    roles: [ROLES.ADMIN]
                }
            },
            {
                action: () => this.toggleView(),
                icon: <SkillProgressIcon />,
                label: 'Progress by skill',
                condition: {
                    show: this.props.type !== 'skill',
                    roles: [ROLES.ADMIN]
                }
            },
            {
                action: () => openDeleteDialog(this.props.id, this.state.compliance.userCount),
                icon:   <DeleteIcon/>,
                label: 'Delete compliance',
                condition: {
                    show: this.context.auth.isRootAdmin()
                }
            }
        ];
    }

    render() {

        if (!this.state.compliance && !this.state.data) { return null; }
        const total = (this.state.compliance ? this.state.compliance[ this.props.type === 'user' ? 'skillCount' : 'userCount'] : null);
        const count = (this.state.compliance ? this.state.compliance[ this.props.type === 'user' ? 'userCount' : 'skillCount'] : null);
        const subtitle = (!!this.props.type && !!count) && `${count} ${this.props.type === 'user' ? 'user' : 'skill'}${count > 1 ? 's' : ''}`;

        return (
            <DetailView
                title="Compliance report"
                actions={buildContextMenu(this.getMenuItems(), this.context.auth)}
                backButton
            >
                <div className="cent-cards">
                    <div className="cent-flex-column cent-col-8">
                        <Card className="cent-card" key="mainContent">
                            <CardHeader
                                title={this.state.compliance ? this.state.compliance.name : ''}
                                subtitle={subtitle}
                                avatar={<IconChart color={statusColours.default} />}
                            />
                            <div className="cent-card-header-buttons">
                                <IconButton onTouchTap={() => this.toggleView()}>
                                    {this.props.type === 'user' ? <SkillProgressIcon/> : <UserProgressIcon/>}
                                </IconButton>
                            </div>

                            <CardText >
                                    {this.state.data.map(dataRow(total, this.props.type))}
                            </CardText>
                        </Card>
                    </div>
                    <div className="cent-flex-column cent-col-4">
                        <Card className="cent-card" key="mainContent">
                            <CardHeader
                                title="Compliance"
                                subtitle=""
                                avatar={<ComplianceIcon color={statusColours.default} />}
                            />
                            <CardText >
                                    <SkillProgress compliance={this.state.compliance} data={this.state.data} />
                            </CardText>
                        </Card>
                    </div>
                </div>
                <ComplianceDeleteDialog/>
            </DetailView>
        );
    }
}

ComplianceProgress.getStores = () => ([ComplianceStore, ComplianceProgressStore]);
ComplianceProgress.calculateState = (prevState, {id, type}) => ({
    compliance: ComplianceStore.get(id),
    data: ComplianceProgressStore.getProgressByCompliance(id, type),
    maxComplete: 100,
    totalCompleted: 0,
});

ComplianceProgress.propTypes = {
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired
};

ComplianceProgress.contextTypes = {
    auth: PropTypes.object
};

const getId = ({routeParams}) => ({id: Number(routeParams.id), type: routeParams.type});
export default withId(Container.create(ComplianceProgress, {withProps: true}), getId);
